import dayjs from 'dayjs'
import { DateFormat } from 'constants/General'
import { CustomerModels } from 'pages/Customers/helpers/types'
import type { CreateBusinessCustomer } from 'types/customers'
import type { AddBusinessCustomerV2FormData } from './types'

export const buildAddBusinessCustomerPayload = (
  data: AddBusinessCustomerV2FormData
): CreateBusinessCustomer => {
  const showOperationalAddress = data.isOperationalAddressDifferent === 'true'

  return {
    onboardingType: CustomerModels.EMBEDDED,
    embeddedPartnerCustomer: {
      useCase: data.useCase,
      company: {
        name: data.name,
        entityType: data.entityType,
        registrationNumber: data.registrationNumber,
        address: {
          addressLine1: data.registeredAddressLine1,
          city: data.registeredAddressCity,
          postalCode: data.registeredAddressPostalCode,
          countryCode: data.registeredAddressCountryCode,
        },
        isOperationalAddressDifferent: showOperationalAddress,
        taxIdentification: {
          number: data.taxNumber,
          taxResidenceCountryCode: data.taxResidenceCountryCode,
        },
        businessProfile: {
          naicsCode: data.naicsCode,
          monthlyExpectedVolumes: data.monthlyExpectedVolumes,
          isRegulated: data.isRegulated === 'true',
          sourceOfFunds: data.sourceOfFunds,
          intendedUseOfAccount: data.intendedUseOfAccount,
        },
        ...(showOperationalAddress && {
          operationalAddress: {
            addressLine1: data.operationalAddressLine1,
            city: data.operationalAddressCity,
            postalCode: data.operationalAddressPostalCode,
            countryCode: data.operationalAddressCountryCode,
          },
        }),
        incorporationDate:
          data.incorporationDate && dayjs(data.incorporationDate).format(DateFormat.YYYY_MM_DD),
        businessOperationsStartDate:
          data.businessOperationsStartDate &&
          dayjs(data.businessOperationsStartDate).format(DateFormat.YYYY_MM_DD),
      },
    },
  }
}
